import { Column, InlineNotification, Row } from "carbon-components-react";

export default function Errors({ errors }) {
    return (
        <Row>
            <Column>
                {errors.map((v) => {
                    return <InlineNotification title={`[${v.param}]`} subtitle={v.msg} kind="error" />
                })}
            </Column>
        </Row>
    )
}